import MatchedResourcesCount from './MatchedResourcesCount';

export default MatchedResourcesCount;
